import API from "@/package/config/axios";
import { ILandingResponse } from "../types/backend-types";
import { cityParams } from "@/modules/user-location";

export const apiGetLandingPage = (city: cityParams) => {
  return API.get<ILandingResponse>(`api/v2/info/home/${city}`);
};
